import { FlexRow } from '@/components/common/Flex';
import { Lock01 } from '@/components/common/icons';
import { InfoButtonWithModal } from '@/components/common/InfoModal';
import { Text } from '@/components/common/Typography';

export const RelationshipStatusLabel = () => (
    <FlexRow alignItems="center">
        Relationship status
        <InfoButtonWithModal
            title="Why do we ask this?"
            buttonProps={{
                onClickEventParams: {
                    location: 'Relationship Status Label',
                },
            }}
        >
            <Text>
                This helps us customize your experience on Plenty, and make
                better decisions about our product roadmap.
            </Text>
            <FlexRow mr={2}>
                <Lock01 mr={2} />
                <Text fontSize="sm">
                    Reminder: your data is encrypted with bank-level security,
                    and will never be shared with third-parties.
                </Text>
            </FlexRow>
        </InfoButtonWithModal>
    </FlexRow>
);
